import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonHttpService } from "src/app/shared/http/json-http.service";
import { ConcurrencyKey, ConcurrencyTicketUI } from "../models/concurrency-key";

@Injectable({
    providedIn: 'root'
})
export class ConcurrencyKeysService {

    constructor(private httpService: JsonHttpService) {
    }

    getConcurrencyKeys(): Promise<ConcurrencyKey[]> {
        return this.httpService.get('/api/concurrency-keys/get-concurrency-keys').toPromise();
    }

    getConcurrencyKeyTickets(concurrencyKeyId?: number): Promise<ConcurrencyTicketUI[]> {
        const options = { params: new HttpParams().set('concurrencyKeyId', concurrencyKeyId) };
        return this.httpService.get('/api/concurrency-keys/get-active-concurrency-tickets', options).toPromise();
    }

    releaseConcurrencyKeyTicket(ticketValue: string): Promise<void> {
        const options = { params: new HttpParams().set('ticketValue', ticketValue) };
        return this.httpService.delete('/api/concurrency-keys/release-concurrency-ticket', options).toPromise();
    }

    saveConcurrencyKeys(concurrencyKey: ConcurrencyKey): Promise<ConcurrencyKey> {
        return this.httpService.post('/api/concurrency-keys/save-concurrency-key', concurrencyKey).toPromise();
    }
}